import BaseInput from '../../atoms/BaseInput';

class InputString extends BaseInput {
  render(): React.ReactElement {
    return this.renderBaseComponent();
  }
}

export default InputString;
